

































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import ObjectSelectSearch from "./object-select-search.vue";
@Component({
  components: {
    ObjectSelectSearch
  }
})
export default class ResearchListContentXianbingshi extends Vue {
  @Prop()
  private content: any;
  private hashKey: any = new Date().getTime();
  private resultOptions: any[] = [];
  /**
   * @description 获取store中的可编辑状态
   */
  private get composeDisabled() {
    return this.$store.state.researchListComposeDiabled;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    const params: any = {
      params: {
        type: "中医症状",
        search: ev
      }
    };
    axios.get("api/project/terms", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.resultOptions = data.data;
      });
    });
  }
  /**
   * @description 删除一个
   */
  private deleteOne(index) {
    this.content.value.splice(index, 1);
    if (this.content.value.length === 0) {
      this.content.value = [{ setting: {}, value: {} }];
    }
  }
  /**
   * @description 添加一个
   */
  private addOne() {
    this.content.value.push({ setting: {}, value: {} });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.hashKey = new Date().getTime();
  }
}
